export default __webpack_public_path__ + "static/media/Saly-43.d37ed130.svg";